// Copyright (c) 2025. CYBERKOALA LLC. All Rights Reserved.
// Proprietary license.

import React, { useState } from 'react';
import type { ViewType } from '@/context/view-context/view-context.tsx';
import { ViewContext } from '@/context/view-context/view-context.tsx';

export const ViewProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [view, setView] = useState<ViewType>('nav');

  return (
    <ViewContext.Provider value={{ view, setView }}>
      {children}
    </ViewContext.Provider>
  );
};
